var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemperature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V18H0z",
    transform: "translate(-45 -545) translate(0 48) translate(0 494) translate(45 3)"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.574.017c-.74 0-1.34.593-1.34 1.324v9.14l.67-.252V1.38c0-.366.3-.695.67-.695.37 0 .67.33.67.695v8.849l.67.252v-9.14c0-.731-.6-1.324-1.34-1.324z",
    transform: "translate(-45 -545) translate(0 48) translate(0 494) translate(45 3) translate(5.4 1.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.244 9.844v.696c.71.267 1.213.944 1.213 1.738 0 1.028-.843 1.86-1.883 1.86s-1.882-.832-1.882-1.86c0-.794.503-1.471 1.212-1.738v-.696c-1.085.29-1.882 1.27-1.882 2.434 0 1.394 1.142 2.523 2.552 2.523 1.41 0 2.553-1.13 2.553-2.523 0-1.164-.798-2.143-1.883-2.434z",
    transform: "translate(-45 -545) translate(0 48) translate(0 494) translate(45 3) translate(5.4 1.8)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5D",
    d: "M2.644.362c0 .185-.148.334-.33.334H.335c-.182 0-.33-.15-.33-.334C.005.178.153.03.335.03h1.979c.182 0 .33.15.33.333z",
    transform: "translate(-45 -545) translate(0 48) translate(0 494) translate(45 3) translate(5.4 1.8) translate(4.524 1.872)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2.644.362c0 .185-.148.334-.33.334H.335c-.182 0-.33-.15-.33-.334C.005.178.153.03.335.03h1.979c.182 0 .33.15.33.333zM1.984 2.015c0 .184-.147.333-.33.333H.335c-.182 0-.33-.15-.33-.333 0-.185.148-.334.33-.334h1.32c.182 0 .33.15.33.334zM1.984 5.32c0 .183-.147.333-.33.333H.335c-.182 0-.33-.15-.33-.334 0-.184.148-.333.33-.333h1.32c.182 0 .33.149.33.333zM2.644 3.667c0 .184-.148.333-.33.333H.335c-.182 0-.33-.149-.33-.333 0-.184.148-.334.33-.334h1.979c.182 0 .33.15.33.334zM2.644 6.971c0 .185-.148.334-.33.334H.335c-.182 0-.33-.15-.33-.334 0-.184.148-.333.33-.333h1.979c.182 0 .33.15.33.333z",
    transform: "translate(-45 -545) translate(0 48) translate(0 494) translate(45 3) translate(5.4 1.8) translate(4.524 1.872)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2.901 5.945c0-.182-.143-.329-.32-.329h-.014c-.177 0-.32.147-.32.329v4.934c-.66.154-1.155.76-1.155 1.483 0 .84.665 1.522 1.482 1.522s1.482-.683 1.482-1.522c0-.723-.495-1.33-1.155-1.483V5.945z",
    transform: "translate(-45 -545) translate(0 48) translate(0 494) translate(45 3) translate(5.4 1.8)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.35d1a0ca.svg";
export { ForwardRef as ReactComponent };